export default __webpack_public_path__ + "static/media/onboardingAside.ea5743b1.png";